import 'bootstrap/dist/css/bootstrap.min.css';
import 'shards-ui/dist/css/shards.min.css';

import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Container } from 'shards-react';
import DocumentPage from './document-page/document-page.component';
import Home from './home/home.component';
import NavBar from './navbar/navbar';
import PastProjects from './past-projects/past-projects.component';
import Slides from './slides/slides.component';

import {CONFIG} from './config';

import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { labs, labSessions, pastProjects, projectSubmission, TAs, slides, syllabus } = CONFIG;
    return (
      <Fragment>
        <Router basename="homes/cs390vr">
          <NavBar labs={labs} projectSubmission={projectSubmission} />
          <Container>
            <Route
              path="/"
              exact
              render={props => (
                <Home {...props} labSessions={labSessions} TAs={TAs} />
              )}
            />
            {labs.map(lab => (
              <Route
                path={lab.route}
                render={props => <DocumentPage {...props} page={lab.url} />}
              />
            ))}
            <Route
              path="/syllabus"
              render={props => (
                <DocumentPage
                  {...props}
                  page={syllabus}
                />
              )}
            />
            <Route
              path="/slides"
              render={props => (
                <Slides slides={slides}/>
              )}
            />
            <Route
              path="/pastprojects"
              render={props => (
                <PastProjects assignments={pastProjects}/>
              )}
            />
          </Container>
        </Router>
      </Fragment>
    );
  }
}
export default App;
